import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms'; // for [(ngModel)]

// Angular Material modules
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio'; 


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AgroDealerListComponent } from './pages/agro-dealer-list/agro-dealer-list.component';
import { ShopDetailsComponent } from './pages/shop-details/shop-details.component';
import { SuccessScreenComponent } from './pages/success-screen/success-screen.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { GenerateOtpComponent } from './pages/generate-otp/generate-otp.component';
import { VerifyOtpComponent } from './pages/verify-otp/verify-otp.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { CapturePhotoComponent } from './pages/capture-photo/capture-photo.component';
import { ViewDealerDetailsComponent } from './pages/view-dealer-details/view-dealer-details.component';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { AuthErrorComponent } from './pages/auth-error/auth-error.component';
import { ExistingDealerComponent } from './pages/existing-dealer/existing-dealer.component';
import { LoadingInterceptor } from './interceptors/loading.interceptor';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { NoInternetComponent } from './components/no-internet/no-internet.component';
import { RouteReuseStrategy } from '@angular/router';
import { CustomRouteReuseStrategy } from './route-reuse-strategy';
@NgModule({
  declarations: [
    AppComponent,
    AgroDealerListComponent,
    ShopDetailsComponent,
    SuccessScreenComponent,
    GenerateOtpComponent,
    VerifyOtpComponent,
    CapturePhotoComponent,
    ViewDealerDetailsComponent,
    AuthErrorComponent,
    ExistingDealerComponent,
    ConfirmationDialogComponent,
    NoInternetComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    // Material Modules
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatListModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatDialogModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
